import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  type InputSignal,
  type OutputEmitterRef,
  type Signal,
} from '@angular/core';
import { UiActionCardTone } from '../../types/ui-action-card-tone.type';

@Component({
  selector: 'ui-action-card',
  imports: [],
  templateUrl: './ui-action-card.component.html',
  styleUrl: './ui-action-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiActionCardComponent {
  public readonly title: InputSignal<string> = input.required<string>();
  public readonly description: InputSignal<string | null> = input<string | null>(null);
  public readonly meta: InputSignal<string | null> = input<string | null>(null);
  public readonly ariaLabel: InputSignal<string | null> = input<string | null>(null);
  public readonly tone: InputSignal<UiActionCardTone> = input<UiActionCardTone>('neutral');
  public readonly disabled: InputSignal<boolean> = input<boolean>(false);
  public readonly selected: OutputEmitterRef<void> = output<void>();

  protected readonly hasDescription: Signal<boolean> = computed((): boolean => !!this.description());
  protected readonly hasMeta: Signal<boolean> = computed((): boolean => !!this.meta());
  protected readonly isNeutral: Signal<boolean> = computed((): boolean => this.tone() === 'neutral');
  protected readonly isPrimary: Signal<boolean> = computed((): boolean => this.tone() === 'primary');
  protected readonly isSuccess: Signal<boolean> = computed((): boolean => this.tone() === 'success');
  protected readonly isWarning: Signal<boolean> = computed((): boolean => this.tone() === 'warning');
  protected readonly isDanger: Signal<boolean> = computed((): boolean => this.tone() === 'danger');

  protected handleSelected(event: MouseEvent): void {
    if (this.disabled()) {
      event.preventDefault();
      return;
    }

    this.selected.emit();
  }
}
